import { Component, HostBinding, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { toScrollAnchorId } from '@innogy/utils-deprecated';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { TrackImpressionDirective } from '@analytics/events';

@Component({
  selector: 'wl-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: [
    './rich-text.component.essent.scss',
    './rich-text.component.ed.scss',
  ],
  standalone: true,
  imports: [RichTextWrapperComponent, TrackImpressionDirective],
})
export class RichTextComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  @HostBinding('attr.id') get id() {
    if (this.rendering?.uid) {
      return toScrollAnchorId(this.rendering.uid);
    }
    return '';
  }
}
